import React from "react";

const Unauthorized: React.FC = () => {
  return (
    <div className="unAuthorizedBox">
      <div className="unAuthorizedLabel">Unauthorized</div>
      <div className="unAuthorizedContent">You do not have permission to access this environment.</div>
    </div>
  );
};

export default Unauthorized;
